export default [
  { type: "accountnum" },
  { type: "birthday" },
  { type: "email" },
  { type: "email_verified" },
  { type: "family_name" },
  { type: "gender" },
  { type: "given_name" },
  { type: "locale" },
  { type: "middle_name" },
  { type: "name" },
  { type: "nickname" },
  { type: "phone_number" },
  { type: "phone_number_verified" },
  { type: "picture" },
  { type: "preferred_username" },
  { type: "profile" },
  { type: "role" },
  { type: "sub" },
  { type: "website" },
  { type: "zoninfo" },
];
